import { createFileRoute } from "@tanstack/react-router";
import { RelatorioCadastroProdutorSimp } from "pages/relatorios/pages/cadastro_produtor_simp";

export const Route = createFileRoute("/a/relatorios/cadastro-produtor-simp")({
	component: RelatorioCadastroProdutorSimp,
});
